import setBreakpoint from './setBreakpoint';
import getBreakpoint from './getBreakpoint';

export default { setBreakpoint, getBreakpoint };



// WEBPACK FOOTER //
// ./node_modules/framework7/components/swiper/swiper-class/components/core/breakpoints/index.js